import * as React from "react";
const LivelihoodIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 56 56",
  "aria-hidden": "true",
  fill: "currentColor",
  width: "1em",
  height: "1em",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#livelihood_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M49.15 28.856h-36.3a.858.858 0 0 0-.85.86v2.14h34.05a.944.944 0 0 1 .95.95v14.05h2.15a.85.85 0 0 0 .85-.85v-16.29a.858.858 0 0 0-.85-.86Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.15 33.856H7.85a.85.85 0 0 0-.85.85v16.29a.858.858 0 0 0 .85.86h36.3a.858.858 0 0 0 .85-.86v-16.29a.85.85 0 0 0-.85-.85Zm-31.15 11a2 2 0 1 1 2-2 2.006 2.006 0 0 1-2 2Zm13 4a6 6 0 1 1 0-12 6 6 0 0 1 0 12Zm13-4a2 2 0 1 1 2-2 2.006 2.006 0 0 1-2 2ZM24.888 16.08l-2.487-.667a5 5 0 0 0-6.124 3.535l-.176.658 2.487.667a4.998 4.998 0 0 0 6.124-3.536l.176-.657Zm-.555 5.732 2.487.666a5 5 0 0 0 6.124-3.535l.176-.658-2.487-.667a5 5 0 0 0-6.124 3.536l-.176.658Zm8.231 2.206 2.488.666a5 5 0 0 0 6.124-3.535l.176-.658-2.488-.667a5 5 0 0 0-6.123 3.536l-.177.658Zm-9.428-11.35 2.488.667.176-.658a5 5 0 0 0-3.536-6.124l-2.487-.666-.176.658a5 5 0 0 0 3.535 6.124Zm8.232 2.206 2.487.667.177-.658a5 5 0 0 0-3.536-6.124l-2.487-.667-.177.659a5 5 0 0 0 3.536 6.123ZM39.6 17.08l2.487.667.176-.66a5 5 0 0 0-3.535-6.122l-2.487-.667-.177.658A5 5 0 0 0 39.6 17.08Zm10.351 4.244a1.42 1.42 0 0 0-1.004-1.74l-5.03-1.347-.736 2.744 5.03 1.348a1.418 1.418 0 0 0 1.74-1.005Zm-39.975-6.3a1.42 1.42 0 1 0-.735 2.744l3.659.98a1.42 1.42 0 1 0 .735-2.743l-3.659-.981Zm2.206-8.231 3.659.98a1.42 1.42 0 1 0 .735-2.744l-3.659-.98a1.42 1.42 0 0 0-.735 2.744Zm4.932 7.203a1.42 1.42 0 1 0 .735-2.744L7.79 8.556a1.42 1.42 0 0 0-.738 2.744l10.062 2.696Z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "livelihood_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h56v56H0z"
}))));
export default LivelihoodIcon;